import React, { memo, useMemo } from "react";
import Button from "./Button";
import { useNavigate } from "react-router-dom";
import { useCurrentForm, useInternalHistory } from "../../Hooks";
import Can from "./Can";
import Icon from "../../../assets/icons/Icon";
import { useSelector } from "react-redux";
import { upperFirstLetterUsingRegex } from "../../helper/common";

const SubHeading = ({
  subTitle = "",
  description = "",
  eyebrow = "Home",
  breadcrumbs = [],
  appendBreadcrumbs = [],
  isAdd = false,
  handleShowHide,
  isImport = false,
  onClick,
  isBack = false,
}) => {
  const navigate = useNavigate();
  const subHeadingDetails = useCurrentForm();
  const descriptionText = description || subHeadingDetails?.formDescription;

  const history = useInternalHistory();

  const handleBack = () => {
    if (history.length > 1) {
      navigate(-1);
    } else {
      navigate("/dashboard");
    }
  };
  const generatedBreadcrumbs = useMemo(() => {
    if (!subHeadingDetails?.formPath) return [];

    const paths = subHeadingDetails.formPath.split("/").filter(Boolean);
    let customPath = "";

    return paths.map((item, index) => {
      const isLast = index === paths.length - 1;
      customPath += `/${item}`;

      return {
        label: isLast
          ? subHeadingDetails?.formName
          : upperFirstLetterUsingRegex(item),
        path: isLast ? null : customPath, // ✅ only change this line
      };
    });
  }, [subHeadingDetails]);

  const finalBreadcrumbs = useMemo(() => {
    if (breadcrumbs?.length > 0) {
      return breadcrumbs;
    }
    if (subTitle) {
      return [{ label: subTitle }];
    }
    if (appendBreadcrumbs?.length > 0) {
      const updatedGenerated = generatedBreadcrumbs.map((item, index) =>
        index === generatedBreadcrumbs.length - 1
          ? { ...item, path: subHeadingDetails?.formPath }
          : item,
      );
      return [...updatedGenerated, ...appendBreadcrumbs];
    }
    return generatedBreadcrumbs;
  }, [
    breadcrumbs,
    subTitle,
    generatedBreadcrumbs,
    appendBreadcrumbs,
    subHeadingDetails,
  ]);

  return (
    <div className="heading_market heading_market--subpage">
      <div className="content_text">
        <h2 className="content_text__eyebrow d-flex align-items-center gap-1 flex-wrap">
          {breadcrumbs?.length > 0 || subTitle ? (
            <>
              <span>{eyebrow}</span>

              {finalBreadcrumbs.map((item, index) => (
                <React.Fragment key={index}>
                  <Icon name="ChevronRight" size={13} />

                  <span
                    className={`${
                      index === finalBreadcrumbs.length - 1
                        ? "menu-text text-primary"
                        : item.path
                          ? "cursor-pointer"
                          : ""
                    }`}
                    onClick={() =>
                      index !== finalBreadcrumbs.length - 1 &&
                      item.path &&
                      navigate(item.path)
                    }
                  >
                    {item.label}
                  </span>
                </React.Fragment>
              ))}
            </>
          ) : (
            finalBreadcrumbs.map((item, index) => {
              const isLast = index === finalBreadcrumbs.length - 1;
              const isFirst = index === 0;

              return (
                <React.Fragment key={index}>
                  {finalBreadcrumbs.length > 1 && index > 0 && (
                    <Icon name="ChevronRight" size={13} />
                  )}

                  <span
                    className={
                      isLast
                        ? "menu-text text-primary"
                        : isFirst
                          ? ""
                          : ` ${item.path ? "cursor-pointer" : ""}`
                    }
                    onClick={() =>
                      !isLast && !isFirst && item.path && navigate(item.path)
                    }
                  >
                    {item.label}
                  </span>
                </React.Fragment>
              );
            })
          )}
        </h2>

        <p className="content_text__description">
          {descriptionText ||
            "Overview of page on relevant information and activity."}
        </p>
      </div>

      <div className="btn_group">
        {isImport && (
          <Button icon="Plus" className="btn btn_main" onClick={onClick}>
            Import
          </Button>
        )}

        {isAdd && (
          <Can action="Add">
            <Button
              icon="Plus"
              className="btn btn_main"
              onClick={() => handleShowHide("add")}
            >
              Add
            </Button>
          </Can>
        )}

        {isBack && (
          <Button
            type="button"
            icon="ArrowLeft"
            className="btn btn_main flex-row-reverse"
            onClick={handleBack}
          >
            Back
          </Button>
        )}
      </div>
    </div>
  );
};

export default memo(SubHeading);
